import api from "../../../../services/api";
import { getApiResponse, handleApiError } from "../helpers/apiResponse";

/**
 * Get department by ID/UUID (Workspace-specific service)
 * Falls back to mock data if API fails
 * 
 * TODO: Remove this service when the original getDepartmentById in src/services/departments.js is stable
 * 
 * @param {string} departmentId - Department ID/UUID
 * @returns {Promise<Object>} API response with department data
 */
export const getDepartmentById = async (departmentId) => {
  if (!departmentId) {
    throw new Error("departmentId is required");
  }

  try {
    const response = await api.get(`/v1/department/${departmentId}`);
    const responseData = response.data;

    // Use helper to normalize response and handle errors
    const normalizedResponse = getApiResponse(
      responseData,
      response,
      'An error occurred while fetching department.'
    );

    return normalizedResponse;

  } catch (error) {
    // Normalize the error using helper
    const normalizedError = handleApiError(error, 'An error occurred while fetching department.');
    
    console.warn("API call failed for getDepartmentById, falling back to mock data:", normalizedError.message);
    
    // Mock fallback - load from mock-department-list.json
    try {
      const mockResponse = await fetch("/mock-department-list.json");
      const mockData = await mockResponse.json();
      
      if (mockData.body && Array.isArray(mockData.body)) {
        // Find department by department_uuid or departmentUuid
        const department = mockData.body.find(
          (dept) => (dept.department_uuid || dept.departmentUuid) === departmentId
        );
        
        if (department) {
          return {
            status_code: 200,
            msg_code: [{ code: "DEPARTMENT_RETRIEVED", description: "Department retrieved successfully from mock data." }],
            request_id: `mock-${Date.now()}`,
            body: department,
            meta: null,
          };
        }
      }
      
      // Department not found in mock
      return {
        status_code: 404,
        msg_code: [{ code: "DEPARTMENT_NOT_FOUND", description: "Department not found." }],
        request_id: `mock-${Date.now()}`,
        body: null,
        meta: null,
      };
    } catch (mockError) {
      console.error("Error fetching mock department data:", mockError);
      return {
        status_code: 404,
        msg_code: [{ code: "DEPARTMENT_NOT_FOUND", description: "Department not found." }],
        request_id: `mock-${Date.now()}`,
        body: null,
        meta: null,
      };
    }
  }
};

